import { render } from "./ktp.vue?vue&type=template&id=37e7e23f"
import script from "./ktp.vue?vue&type=script&lang=js"
export * from "./ktp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__